



























































































































































import { Component, Prop, PropSync, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import VCustomer from "@/shared/models/vCustomer";
import { ReservationModel, ReservationCustomerModel, DistributionChannelTypesEnum } from "./types";
import { Country } from "@/shared/models/country";
import { CustomerModel } from "@/shared/models/vCustomer";
import RightDrawer from "@/components/misc/RightDrawer.vue";
import CustomerForm from "@/components/CustomerForm.vue";
import CustomerFormMobile from "@/components/CustomerFormMobile.vue";
import CustomerLookup from "@/components/misc/CustomerLookup.vue";
import CustomerLookupMobile from "@/components/misc/CustomerLookupMobile.vue";
import * as _ from "lodash";
import { SalesChannelView } from "@/shared/models/salesChannel";
import { cleanUpPhoneNumber, cleanUpLeadingZeroes, appendPrefixIfMissing } from "@/shared/commonFunctions";
import GuestReservationHistoryTable from "../GuestReservationHistoryTable.vue";
import GuestReservationHistoryTableMobile from "../GuestReservationHistoryTableMobile.vue";
import { policyChecker } from "@/shared/roles";
import { JwtClaims } from "@/store/modules/auth";

@Component({
  components: {
    RightDrawer,
    CustomerForm,
    CustomerFormMobile,
    CustomerLookup,
    CustomerLookupMobile,
    GuestReservationHistoryTable,
    GuestReservationHistoryTableMobile
  },
})
export default class ReservationFormHolder extends Vue {
  @PropSync("reservation") model?: ReservationModel | null;

  @Prop() isMobile?: boolean;

  @Getter("auth/claims") claims?: JwtClaims;

  @Action("codebooks/refreshCountries") refreshCountries?: () => Promise<void>;
  @Getter("codebooks/countries") countries?: Country[];

  @Action("codebooks/refreshSalesChannels")
  refreshSalesChannels?: () => Promise<void>;
  @Getter("codebooks/salesChannels") salesChannels?: SalesChannelView[];

  lookupOpen = false;
  customerFormOpen = false;
  guestHistoryOpen = false;

  @Watch("model", { immediate: true })
  reservationChanged() {
    this.selectedCustomer = _.cloneDeep(this.model?.customer ?? null);
  }

  @Watch("model.customer.name")
  nameWatch(fresh: string) {
    if (!fresh && this.model) {
      this.model.customerId = 0;
      this.model.customer = new ReservationCustomerModel();
      this.selectedCustomer = null;
    }
  }

  get isAllowedGuestHistory() {
    return (
      policyChecker("GUEST_HISTORY")(this.claims)
    );
  }

  get isAllowedToEditEmail() {
    return (
      policyChecker("EDIT_RESERVATION_HOLDER_EMAIL")(this.claims)
    );
  }

  get isOwnerLevel3() {
    return (
      policyChecker("OWNER_LEVEL_3")(this.claims)
    );
  }

  get showEmail() {
    return policyChecker("READ_CUSTOMER_EMAIL")(this.claims);
  }

  get isAllowedToSeeTelephoneNumber() {
    return policyChecker("READ_CUSTOMER_TELEPHONE_NUMBER")(this.claims);
  }

  async created() {
    const promises = [];
    if ((this.countries?.length ?? 0) === 0 && this.refreshCountries) {
      promises.push(this.refreshCountries());
    }
    if ((this.salesChannels?.length ?? 0) === 0 && this.refreshSalesChannels) {
      promises.push(this.refreshSalesChannels());
    }
    await Promise.all(promises);
  }

  selectedCustomer: any = null;
  selected(customer: VCustomer | CustomerModel) {
    if (this.model) {
      const identificationNumber = (customer as VCustomer).name ? (customer as VCustomer).identificationNumber : ((customer as CustomerModel).isLegalEntity ? (customer as CustomerModel).businessId : (customer as CustomerModel).identificationDocumentNumber);

      this.model.customerId = customer.id;
      this.model.customer = {
        id: customer.id,
        name: (customer as VCustomer).name
          ? (customer as VCustomer).name
          : (customer as CustomerModel).isLegalEntity
            ? ((customer as CustomerModel).legalEntityName ?? "")
            : (customer as CustomerModel).firstName +
              " " +
              (customer as CustomerModel).lastName,
        eMail: customer.eMail || "",
        telephoneNumber: customer.telephoneNumber || "",
        countryOfResidenceId: customer.countryOfResidenceId,
        isLegalEntity: (customer as VCustomer).name ? false : (customer as CustomerModel).isLegalEntity,
        identificationNumber: identificationNumber ?? "",
        status: true,
      };
      const salesChannelDefault = this.salesChannels?.find(x => x.defaultCustomerId == this.model?.customerId);
      if(salesChannelDefault){
        this.model.distributionChannelTypeId = DistributionChannelTypesEnum.PartnerAgency;
        this.model.salesChannelId = salesChannelDefault.id
      }

      this.selectedCustomer = _.cloneDeep(this.model.customer);
    }
  }

  get rules() {
    return {
      reservationHolder: (value: any) =>
        !!value || this.$t("Reservation.HolderIsRequired"),
    };
  }

  get phonehref()
  {
    let phoneNumber = this.model ? cleanUpPhoneNumber(this.model.customer.telephoneNumber) : "";

    phoneNumber = appendPrefixIfMissing(phoneNumber);

    return "tel:" + phoneNumber;
  }

  get smshref()
  {
    let phoneNumber = this.model ? cleanUpPhoneNumber(this.model.customer.telephoneNumber) : "";

    phoneNumber = appendPrefixIfMissing(phoneNumber);

    return "sms:" + phoneNumber;
  }

  get whatsapphref()
  {
    return this.model ? "https://wa.me/" + cleanUpLeadingZeroes(cleanUpPhoneNumber(this.model.customer.telephoneNumber)) : "";
  }

  get hasPhoneNumber()
  {
    return this.model?.customer.telephoneNumber ? this.model?.customer.telephoneNumber.trim().length ?? 0 > 0 : false;
  }

  get filterPrefil() {
    return {
      name: this.model?.customer.name ?? "",
      eMail: this.model?.customer.eMail ?? "",
      telephoneNumber: this.model?.customer.telephoneNumber ?? "",
    };
  }

  onInputLostFocus() {
    if (this.selectedCustomer && this.model) {
      this.model.customer.name = this.selectedCustomer.name;
      this.model.customer.eMail = this.selectedCustomer.eMail;
      this.model.customer.telephoneNumber = this.selectedCustomer.telephoneNumber;
    }
  }

  edited(customer: CustomerModel) {
    if (
      this.model &&
      this.model.customerId &&
      this.model.customerId == customer.id
    ) {
      this.model.customer.name =
        customer.firstName +
        (customer.middleName ? ` ${customer.middleName}` : "") +
        ` ${customer.lastName}`;
      this.model.customer.eMail = customer.eMail ?? "";
      this.model.customer.telephoneNumber = customer.telephoneNumber ?? "";
      this.model.customer.countryOfResidenceId = customer.countryOfResidenceId;

      this.selectedCustomer = _.cloneDeep(this.model.customer);
    }
  }
}
